export enum AppRoutes {
  NOT_FOUND = "not-found",
  PROJECTS = "projects",
  PROJECT_DETAILS = "project",
  SIGN_IN = "sign-in",
  SIGN_UP = "sign-up",
  CREATE_PROJECT = "create-project",
  PRIVACY_NOTICE = "privacy-notice",
  TERMS_OF_USE = "terms-of-use",
  EDIT_PROJECT = "projects/:id/edit",
  NEW_VERSION = "projects/new-version/:projectId",
  REVIEW_RELAUNCH = "projects/review-relaunch/:projectId",
  SETTINGS = "settings",
  FORGOT_PASSWORD = "forgot-password",
  RESET_PASSWORD = "reset-password",
  COOKIE_NOTICE = "cookie-notice",
  VERIFY_OTP = "verify-otp"
}

export const getRouteProjects = () => "/";
export const getRouteProjectDetails = (id: number | string) => `/projects/${id}`;
export const getRouteCreateProject = () => `/${AppRoutes.CREATE_PROJECT}`;
export const getRouteSignIn = () => `/${AppRoutes.SIGN_IN}`;
export const getRouteSignUp = () => `/${AppRoutes.SIGN_UP}`;
export const getRoutePrivacyNotice = () => `/${AppRoutes.PRIVACY_NOTICE}`;
export const getRouteTermsOfUse = () => `/${AppRoutes.TERMS_OF_USE}`;
export const getRouteEditProject = (id: number | string) => `/projects/${id}/edit`;
export const getRouteNewVersion = (id: number | string) => `/projects/new-version/${id}`;
export const getRouteReviewRelaunch = (id: number | string) => `/projects/review-relaunch/${id}`;
export const getRouteSettings = () => `/${AppRoutes.SETTINGS}`;
export const getRouteForgotPassword = () => `/${AppRoutes.FORGOT_PASSWORD}`;
export const getRouteResetPassword = () => `/${AppRoutes.RESET_PASSWORD}`;
export const getRouteCookieNotice = () => `/${AppRoutes.COOKIE_NOTICE}`;
export const getRouteVerifyOtp = () => `/${AppRoutes.VERIFY_OTP}`;
